var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "select-wrap" }, [
      _c(
        "div",
        [
          _c("span", [_vm._v("交易时间")]),
          _vm._v(" "),
          _c("el-date-picker", {
            attrs: {
              clearable: false,
              "unlink-panels": "",
              type: "daterange",
              format: "yyyy-MM-dd",
              "range-separator": "-",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              size: "small"
            },
            on: { change: _vm.onChangeTime },
            model: {
              value: _vm.time,
              callback: function($$v) {
                _vm.time = $$v
              },
              expression: "time"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "select-company" },
        [
          _c("span", [_vm._v("交易类型")]),
          _vm._v(" "),
          _c(
            "el-select",
            {
              attrs: {
                clearable: "",
                size: "small",
                placeholder: "请选择交易类型"
              },
              model: {
                value: _vm.trxType,
                callback: function($$v) {
                  _vm.trxType = $$v
                },
                expression: "trxType"
              }
            },
            _vm._l(_vm.trxOptions, function(item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.name, value: item.id }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.getData }
            },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.exportDetail }
            },
            [_vm._v("导出明细")]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "jzbWrap" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            staticStyle: { width: "100%" },
            attrs: { data: _vm.tableData },
            on: { "expand-change": _vm.expandChange }
          },
          [
            _c("el-table-column", {
              attrs: { type: "expand" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(props) {
                    return [
                      _c(
                        "div",
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { data: props.row.child }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { prop: "serialNum", label: "序号" }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "saleOrder",
                                  label: "销售单号/退货单号"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { prop: "skuCode", label: "商品编码" }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { prop: "skuName", label: "商品名称" }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { prop: "price", label: "单价" }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { prop: "quantity", label: "数量" }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { prop: "totalAmount", label: "总金额" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "createdOn", label: "交易时间" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.moment(scope.row.tradeTime).format("YYYY-MM-DD")
                          ) +
                          "\n        "
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "operationType", label: "交易类型" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm._f("filterOperationType")(scope.row.trxType)
                          ) +
                          "\n        "
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "settleNo", label: "单号" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "amount", label: "交易金额" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _vm._v(
                        "\n          " + _vm._s(scope.row.amount) + "\n        "
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "operationType", label: "转账状态" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function(scope) {
                      return scope.row.trxType === 6
                        ? [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm._f("filterTransferType")(
                                    scope.row.transferStatus
                                  )
                                ) +
                                "\n        "
                            )
                          ]
                        : undefined
                    }
                  }
                ],
                null,
                true
              )
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "payType", label: "支付方式" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "chargeType", label: "费用类型" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "corpName", label: "公司" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("el-pagination", {
          attrs: {
            "current-page": _vm.currentPage,
            "page-sizes": [10, 50, 100, 200],
            "page-size": _vm.pagesize,
            layout: "total, sizes, prev, pager, next, jumper",
            total: _vm.totalCount
          },
          on: {
            "size-change": _vm.handleSizeChange,
            "current-change": _vm.handleCurrentChange
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f77936a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f77936a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/purseSetting/record/components/RuiGuTransDetail.vue
// module id = null
// module chunks = 